import { render } from "./IconReview.vue?vue&type=template&id=3ca1bb8e"
import script from "./IconReview.vue?vue&type=script&lang=js"
export * from "./IconReview.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__